import { render, staticRenderFns } from "./NFTFallback.vue?vue&type=template&id=a87dfa9a&scoped=true&"
import script from "./NFTFallback.vue?vue&type=script&lang=ts&"
export * from "./NFTFallback.vue?vue&type=script&lang=ts&"
import style0 from "./NFTFallback.vue?vue&type=style&index=0&id=a87dfa9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87dfa9a",
  null
  
)

export default component.exports